// import logo from './logo.svg';
// import './App.css';
import About from './components/About.jsx';
import Skills from './components/Skills.jsx';
import Projects from './components/Projects.jsx';

function App() {
  return (
    <main className='text-main-text font-nunito'>
      <About></About>
      <Skills></Skills>
      <Projects></Projects>
    </main>
    
  );
}

export default App;
